import React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

// layouts
import { Cabecalho, PainelLateral, Conteudo, Rodape } from 'componentes/Layout';

// paginas
import Processo from "paginas/processo";
import TramitacaoProcesso from "paginas/tramitacao";
import Parecer from "paginas/parecer";
import Decisao from "paginas/decisao";
import PesquisaProcesso from 'paginas/pesquisaprocesso';

import Mensagem from "componentes/mensagem";
import { exibirMensagem } from "componentes/mensagem/actions";
import {
  MdLoyalty,
  MdImportantDevices
} from 'react-icons/lib/md';

import "./estilos/sgri.css";
import "react-multiselect-two-sides/style.css";

var oldFetch = fetch;  // dever ser escopo global

class App extends React.Component {
  static isSidebarOpen() {
    return document
      .querySelector('.sr-sidebar')
      .classList.contains('sr-sidebar--open');
  }

  static interceptarFetch(url, options = {}) {
    return oldFetch(url, { ...options, credentials: "include" })
      .then(response => {
        /**/
    	if (/401/.test(response.status)) {
          return response
            .json()
            .then(({ autentikusRedirect: urlTelaLogin }) => {
              const { href: urlDeRetorno } = window.location;
              setTimeout(() => {
                window.location.replace(`${urlTelaLogin}&redirect_uri=${urlDeRetorno}`);
              }, 4000);
              return Promise.reject("Não autorizado ou sessão expirada! Abrindo tela de login...");
            });
        }
    	/**/
        return Promise.resolve(response);
      });
  }

  componentWillReceiveProps({ breakpoint }) {
    if (breakpoint !== this.props.breakpoint) {
      this.checkBreakpoint(breakpoint);
    }
  }

  componentDidMount() {
    this.checkBreakpoint(this.props.breakpoint);
    setTimeout(() => this.props.exibirMensagem({
      icone: MdLoyalty,
      msg: "Bem vindo ao RADAR!",
      tipo: "info"
    }), 1500);

    setTimeout(() => this.props.exibirMensagem({
      icone: MdImportantDevices,
      msg: "RADAR faça seus recursos on line com toda comodidade.",
      tipo: "info"
    }), 2500);
  }

  // close sidebar when
  handleConteudoClick = event => {
    // close sidebar if sidebar is open and screen size is less than `md`
    if (
      App.isSidebarOpen() &&
      (this.props.breakpoint === 'xs' ||
        this.props.breakpoint === 'sm' ||
        this.props.breakpoint === 'md')
    ) {
      this.openSidebar('close');
    }
  };

  checkBreakpoint(breakpoint) {
    switch (breakpoint) {
      case 'xs':
      case 'sm':
      case 'md':
        return this.openSidebar('close');

      case 'lg':
      case 'xl':
      default:
        return this.openSidebar('open');
    }
  }

  openSidebar(openOrClose) {
    if (openOrClose === 'open') {
      return document
        .querySelector('.sr-sidebar')
        .classList.add('sr-sidebar--open');
    }

    document.querySelector('.sr-sidebar').classList.remove('sr-sidebar--open');
  }

  render() {
    return (
      <BrowserRouter>
        <main className="sr-app bg-light">
          <PainelLateral />
          <Conteudo fluid onClick={this.handleConteudoClick}>
            <Cabecalho />
            <Switch>
              <Route exact path="/" component={Processo} />
              <Route path="/processo/:id/atualizar" component={Processo} />
              <Route path="/processo/:id/tramitar/:de" component={TramitacaoProcesso} />
              <Route path="/processo/:id/parecer" component={Parecer} />
              <Route path="/processo/:id/decisao" component={Decisao} />
              <Route path="/pesquisa" component={PesquisaProcesso} />
              <Redirect to="/" />
            </Switch>
            <Rodape />
          </Conteudo>
          <Mensagem />
        </main>
      </BrowserRouter>
    );
  }
}

fetch = App.interceptarFetch;

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => bindActionCreators({
  exibirMensagem
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js